// faq tabs toggal start
function togal_tabs (item) {
  item.addEventListener("click", () => {
     toggal_all_tabs(item.getAttribute('data-faq_content'));
  });        
}
function toggal_all_tabs(tabs_data){
  let tabs_button = document.querySelectorAll("[data-faq_content]");
  tabs_button.forEach(b => {
    if(b.getAttribute('data-faq_content') == tabs_data){
      if(b.classList.contains('is_open')){
         b.classList.remove("is_open");
        }else{
         b.classList.add("is_open");
        }
    }else{
       b.classList.remove("is_open");
    }
  });
}
function faq_taggol() {
  let tabs_title = document.querySelectorAll("[data-faq_content]");
      tabs_title.forEach(togal_tabs);
}
faq_taggol();
// faq tabs toggal end

if (document.querySelector('.custom_play_btn')) {
  document.querySelector('.custom_play_btn').addEventListener('click', function() {
    var video = document.getElementById('myVideo_custom');
    document.getElementById('videoPoster').classList.add('hidden');
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  });
}


var swiper = new Swiper(".review-main-slider .review-slider",{
    slidesPerView: 3,
    spaceBetween: 15,
    centeredSlides: false,
    loop: false,
    breakpoints: {
        0: {
            slidesPerView: 1,
            spaceBetween: 20,
            autoHeight: true
        },
        640: {
            slidesPerView: 2,
            spaceBetween: 20
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 30
        },
        990: {
            slidesPerView: 3,
            spaceBetween: 15
        }
    },
    scrollbar: {
        el: ".swiper-scrollbar"
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
});

// slider popup slider

// var swiper = new Swiper(".testi_slider .review-slider",{
//     slidesPerView: 1,
//     spaceBetween: 15,
//     slidesPerGroup: 1,
//     slideShow:1,
//     navigation: {
//       nextEl: ".swiper-button-next",
//       prevEl: ".swiper-button-prev",
//     },
// });


if(window.innerWidth <= 1024) {
   var swiper = new Swiper(".custom_faq_tab", {
    slidesPerView: 1,
    spaceBetween: 10,
  });
}

// var swiper = new Swiper(".tab_slider", {
//   slidesPerView: 1,
//   spaceBetween: 20,
//   loop:true, 
//   direction:"horizontal", 
//   keyboard:{
//    enabled:true,
//    onlyInViewport:true
//   },
//   effect:"slide",
//   speed:1500
// });

  var swiper = new Swiper(".collection_page_custom",{
    slidesPerView: 6,
    spaceBetween: 25,
    loop: false,
    navigation:{
      nextEl:".swiper-button-next",
      prevEl:".swiper-button-prev"
    },
     breakpoints:{
       275: {
               slidesPerView:2.5,
               spaceBetween: 0
            },  
       375: {
               slidesPerView:2.5,
               spaceBetween: 0
            },
         420: {
               slidesPerView:3.2,
               spaceBetween: 0
            },
         640: {
               slidesPerView:3.5,
               spaceBetween: 0
            },
         768: {
               slidesPerView:4.6,
               spaceBetween: 0
            }, 
         1025: {
            slidesPerView: 6
          }
        }
  });

document.addEventListener("DOMContentLoaded", function () {
    var swiperWrapper = document.querySelector(".collection_page_custom .swiper-wrapper");
        if (swiperWrapper) {
        var slides = swiperWrapper.querySelectorAll(".swiper-slide");
                if (slides.length > 6) {
            swiperWrapper.classList.add("custom_swipe_slies");
        }
    }
});


// product main media slider

if (document.querySelector('.product_thumbnail') != null) {
  var Product_swiper = new Swiper(".custom_slider_pdp[custom_product_slider]",{
      slidesPerView:1,
      spaceBetween:10,
      navigation:{
        nextEl:".pdp.swiper-button-next",
        prevEl:".pdp.swiper-button-prev"
      },
      keyboard:{
        enabled:true,
        onlyInViewport:true
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      allowTouchMove: true,
      speed:500,
      thumbs:{
        swiper:{
          slidesPerView:5,
          el:".swiprt_thumbnail_slider",
          slidesPerView:1,
          spaceBetween:15,
          slideThumbActiveClass: "swiper-slide-thumb-active",
          // navigation:{
          //     nextEl:".swiper-button-next.thumb",
          //     prevEl:".swiper-button-prev.thumb"
          // },
          breakpoints:{
            0: {
                 slidesPerView:4,
              },
           1025: {
              slidesPerView: 5,
             direction: "vertical"
            }
          }
        }
      }
  });  
}else{
  var Product_swiper = new Swiper(".custom_slider_pdp[custom_product_slider]",{
      slidesPerView:1,
      spaceBetween:10,
      navigation:{
        nextEl:".pdp.swiper-button-next",
        prevEl:".pdp.swiper-button-prev"
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      keyboard:{
        enabled:true,
        onlyInViewport:true
      },
      allowTouchMove: true,
      speed:500
  }); 
}


// var dta = document.querySelectorAll('.our-item');
// dta.forEach(b => {
//     b.addEventListener("click", () => {
//       var maiN_to = b.querySelector('.popup_data');
//       maiN_to.style.display = 'block';
//     });
// });

// window.onload = function() {
//   if (!document.querySelector("body").classList.contains('tmp-index')) return;
//     setTimeout(function() {
//         var maiN_to = document.querySelector('.discount__popup');
//       if (maiN_to) {        
//         maiN_to.style.display = 'block';
//         document.body.classList.add('popup-active');
//       }
//     }, 1000); // 60000 milliseconds = 1 minute
// };

// var dta = document.querySelectorAll('.discount_popup');
// dta.forEach(b => {
//     // Add click event to show the popup
//     b.addEventListener("click", (event) => {
//         // Show the popup
//         var maiN_to = document.querySelector('.popup_data');
//         maiN_to.style.display = 'block';

//         // Add a class to the body
//         document.body.classList.add('popup-active');
//     });
//     // Close button inside the popup
//     var closeBtn = document.querySelector('.disc_close');
//     if (closeBtn) {
//         closeBtn.addEventListener("click", (event) => {
//             // Prevent the click from bubbling up to the parent elements
//             event.stopPropagation();

//             // Hide the popup
//             var maiN_to = document.querySelector('.popup_data');
//             maiN_to.style.display = 'none';

//             // Remove the class from the body
//             document.body.classList.remove('popup-active');
//         });
//     }
// });

// Function to set a cookie
function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // Convert days to milliseconds
    const expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

// Function to get a cookie
function getCookie(name) {
    const nameEQ = name + "=";
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        let c = cookies[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

// Display the newsletter popup only if the cookie is not set
window.onload = function () {
    if (!document.querySelector("body").classList.contains('tmp-index')) return;

    const popupCookie = getCookie("newsletter_popup");
    if (!popupCookie) {
        setTimeout(function () {
            const maiN_to = document.querySelector('.discount__popup');
            if (maiN_to) {
                maiN_to.style.display = 'block';
                document.body.classList.add('popup-active');

                // Set the cookie for 1 day
                setCookie("newsletter_popup", "shown", 1);
            }
        }, 1000); // Show popup after 1 second
    }
};

// Handle click events for showing and closing the popup
var dta = document.querySelectorAll('.discount_popup');
dta.forEach(b => {
    // Add click event to show the popup
    b.addEventListener("click", (event) => {
        // Show the popup
      window._klOnsite = window._klOnsite || []; 
      window._klOnsite.push(['openForm', 'SF2qch']);
        // var maiN_to = document.querySelector('.popup_data');
        // if (maiN_to) {
        //     maiN_to.style.display = 'block';
        //     document.body.classList.add('popup-active');
        // }
    });

    // Close button inside the popup
    var closeBtn = document.querySelector('.disc_close');
    if (closeBtn) {
        closeBtn.addEventListener("click", (event) => {
            // Prevent the click from bubbling up to the parent elements
            event.stopPropagation();

            // Hide the popup
            var maiN_to = document.querySelector('.popup_data');
            if (maiN_to) {
                maiN_to.style.display = 'none';
                document.body.classList.remove('popup-active');
            }
        });
    }
});



var dta = document.querySelectorAll('.our-item-slide');
dta.forEach(b => {
    // Add click event to show the popup
    b.addEventListener("click", (event) => {
      // Show the popup
      var maiN_to = b.querySelector('.popup_data');
     if (maiN_to) {
        maiN_to.style.display = 'block';
        document.body.classList.add('popup-active'); 
     }        
    });
    // Close button inside the popup
    var closeBtn = b.querySelector('.close_btn');
    if (closeBtn) {
        closeBtn.addEventListener("click", (event) => {
            // Prevent the click from bubbling up to the parent elements
            event.stopPropagation();

            // Hide the popup
            var maiN_to = b.querySelector('.popup_data');
            if (maiN_to) {
             maiN_to.style.display = 'none';
             document.body.classList.remove('popup-active'); 
            }
        });
    }
});

var dta = document.querySelectorAll('.slider_logo');
dta.forEach(b => {
    // Add click event to show the popup
      var popu_data = b.getAttribute('popu_data');
    b.addEventListener("click", (event) => {
      var maiN_to = document.querySelector('.popup_data[popu_data='+ popu_data +']');
      if (maiN_to) {
        maiN_to.style.display = 'block';
        document.body.classList.add('popup-active2');
      }
    });

    // Close button inside the popup
    var closeBtn = document.querySelectorAll('.close_btn');
    if (closeBtn) {
      closeBtn.forEach(b => {
        b.addEventListener("click", (event) => {
            // Prevent the click from bubbling up to the parent elements
            event.stopPropagation();
            var maiN_to = document.querySelector('.popup_data[popu_data='+ popu_data +']');
            if (maiN_to) {              
              maiN_to.style.display = 'none';
              document.body.classList.remove('popup-active2');
            }
        });
      });
    }
  });

if (document.querySelector('.open_filter_cls')) {
  document.querySelector('.open_filter_cls').addEventListener('click', function() {
    this.classList.toggle('filter_active');
    document.getElementById('FacetsWrapperDesktop').classList.toggle('dd_cm_filter');
    document.querySelector('[aria-labelledby="verticalTitle"]').classList.toggle('dd_filter');
  });
}

function shareLink(button) {
  var getShareURL = button.getAttribute("data-share-url");

  if (navigator.share) {
    navigator.share({
      title: 'Check out this link',
      text: '',
      url: getShareURL
    })
    .then(() => console.log('Shared successfully'))
    .catch(error => console.log('Error sharing:', error));
  } else {
    console.log("Web Share API not supported.");
    copyToClipboard(getShareURL);
  }
}

function copyToClipboard(text) {
  navigator.clipboard.writeText(text);
}



document.querySelectorAll('.custom_main_link').forEach(function(element) {
    element.addEventListener('mouseenter', function() {
        var dataTitle = this.getAttribute('link_title');

        // Remove 'active' class from all elements with class '.custom_main_link' and attribute 'data_title'
        document.querySelectorAll('.header_custom_d .custom_main_link[data_title]').forEach(function(link) {
            link.classList.remove('active');
        });

        // Add 'active' class to the hovered element
        this.classList.add('active');

        // Add 'hide' class to all elements with class '.custom_mega-penal' and attribute 'data_title'
        document.querySelectorAll('.custom_mega-penal[link_title]').forEach(function(panel) {
            panel.classList.add('hidden');
        });

       document.querySelectorAll('.col_images_da[link_title]').forEach(function(img) {
            img.classList.add('hidden');
        });

        // Remove 'hide' class from the specific '.custom_mega-penal' that matches the hovered element's 'link_title' value
        if(document.querySelector('.custom_mega-penal[link_title="' + dataTitle + '"]')){ document.querySelector('.custom_mega-penal[link_title="' + dataTitle + '"]').classList.remove('hidden'); }

      if(document.querySelector('.col_images_da[link_title="' + dataTitle + '"]')){ document.querySelector('.col_images_da[link_title="' + dataTitle + '"]').classList.remove('hidden'); }
    });
});

//topbar trigger click
document.addEventListener('DOMContentLoaded', function () {
  const leftLink = document.querySelector('.leftText_cls a');

  if (leftLink) {
    leftLink.addEventListener('click', function () {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'Yr8eVg']);
    });
  }
});


//pdp Description load more
document.addEventListener('DOMContentLoaded', function () {
  const loadMoreBtn = document.querySelector('.dsc_mehrinfo_btn');
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function () {
      event.preventDefault();
      const nextSection = document.querySelector('.image_accordiannt');
  
      if (nextSection) {
        nextSection.scrollIntoView({ behavior: 'smooth' });
        const nextTab = document.querySelector('.left-col'); 
        if (nextTab) {
          nextTab.click(); 
        }
      }
    });
  }  
});


